var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirIcoSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29695_82205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0.00000104907,
    width: 24,
    height: 24,
    transform: "rotate(90 24 1.04907e-06)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29695_82205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65061 14.7004L12.0006 18.0504L15.3506 14.7004L8.65061 14.7004ZM8.25061 15.2754C8.01728 15.0421 7.96311 14.7712 8.08811 14.4629C8.21311 14.1546 8.44228 14.0004 8.77561 14.0004L15.2256 14.0004C15.5589 14.0004 15.7881 14.1546 15.9131 14.4629C16.0381 14.7712 15.9839 15.0421 15.7506 15.2754L12.5256 18.5004C12.4423 18.5837 12.3589 18.6421 12.2756 18.6754C12.1923 18.7087 12.1006 18.7254 12.0006 18.7254C11.9006 18.7254 11.8089 18.7087 11.7256 18.6754C11.6423 18.6421 11.5589 18.5837 11.4756 18.5004L8.25061 15.2754ZM8.25061 8.72539L11.4756 5.50039C11.5589 5.41706 11.6423 5.35872 11.7256 5.32539C11.8089 5.29206 11.9006 5.27539 12.0006 5.27539C12.1006 5.27539 12.1923 5.29206 12.2756 5.32539C12.3589 5.35872 12.4423 5.41706 12.5256 5.50039L15.7506 8.72539C15.9839 8.95873 16.0381 9.22956 15.9131 9.53789C15.7881 9.84623 15.5589 10.0004 15.2256 10.0004L8.77561 10.0004C8.44228 10.0004 8.21311 9.84623 8.08811 9.53789C7.96311 9.22956 8.01728 8.95872 8.25061 8.72539Z",
    fill: "#535B5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirIcoSort);
export default __webpack_public_path__ + "static/media/mir-ico-sort.30a00034a08408464a9e7a33a060b781.svg";
export { ForwardRef as ReactComponent };